import dynaForms from '@elab/core/utils/dynaForms';

import { storeName } from './types';

export default dynaForms.getActions(storeName);
